import { useEffect } from 'react';
import { RadioButton } from 'ui';
import { AlertBlueIcon } from 'ui/icons';
import { goodFormatUSDCurrency } from 'ui/utils';
import { RoundTo } from 'api';

interface FractionalSharesProps {
  value: RoundTo;
  amount: number;
  amountExcess: number;
  roundDownShares: number;
  roundUpShares: number;
  price_per_share: number;
  onChange: (value: RoundTo) => void;
  inFuture?: boolean;
}

const FractionalShares = ({
  value,
  amount,
  amountExcess,
  roundUpShares,
  price_per_share,
  roundDownShares,
  onChange,
  inFuture = false,
}: FractionalSharesProps) => {
  useEffect(() => {
    if (roundDownShares === 0 && value === RoundTo.Down) {
      onChange(RoundTo.Up);
    }
  }, [onChange, roundDownShares, value]);

  return (
    <div className="flex gap-3 items-start bg-[rgba(3,105,161,0.08)] py-3 px-4">
      <img src={AlertBlueIcon} alt="info" />
      <div className="flex flex-col gap-3 flex-1">
        <div>
          <span className="text-sm">
            The investor {!inFuture ? `paid ` : 'will pay '}
            {goodFormatUSDCurrency(
              roundDownShares ? amountExcess : Math.abs(amount - price_per_share),
            )}{' '}
            {roundDownShares ? 'more' : 'less'} than the required amount
          </span>
          <br />
          <span className="text-xs text-gray-500">Round up or down to approve operation.</span>
        </div>
        <RadioButton
          onChange={onChange}
          value={value}
          className="flex select-none"
          items={[
            {
              label: (
                <div>
                  <span>Round Down</span>
                  <span className="text-gray-500"> {roundDownShares} shares</span>
                </div>
              ),
              value: RoundTo.Down,
              disabled: !roundDownShares,
            },
            {
              label: (
                <div>
                  <span>Round up</span>
                  <span className="text-gray-500"> {roundUpShares} shares</span>
                </div>
              ),
              value: RoundTo.Up,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default FractionalShares;
